import type { HourReporterMemberSummary, HourReporterMembershipResponse } from "./schemas"

export type MemberSummary = HourReporterMemberSummary & {
  fullname: string
}

export type HourReporterMembershipViewModel = MemberSummary & {
  checkers: MemberSummary[]
  approvers: MemberSummary[]
  reporterCountForCheck: number
  reporterCountForApproval: number
}

export const makeHourReporterMembershipViewModel = (
  membership: HourReporterMembershipResponse
): HourReporterMembershipViewModel => {
  return {
    ...makeMemberSummary(membership),
    checkers: membership.checkers.map(makeMemberSummary),
    approvers: membership.approvers.map(makeMemberSummary),
    reporterCountForCheck: membership.reporterCountForCheck,
    reporterCountForApproval: membership.reporterCountForApproval,
  }
}

const makeMemberSummary = (membership: HourReporterMemberSummary): MemberSummary => {
  return {
    ...membership,
    fullname: `${membership.firstname} ${membership.lastname}`.trim(),
  }
}
